module.exports = __webpack_public_path__ + "static/media/retirement-placeholder.473890f2.webp";